import { selectWarehouses } from 'containers/Warehouses/warehousesSlice'
import useTranslation from 'hooks/useTranslation'
import Select from 'components/inputs/Select'
import { useHistory } from 'react-router-dom'
import { useSelector } from 'react-redux'
import Popup from '../popups/Popup'
import DateInput from './DateInput'
import { useState } from 'react'

const FilterPopup = ({ filters: startFilters = {}, fields = [], setFilters: saveFilters = () => { } }) => {

  const [filters, setFilters] = useState(startFilters)
  const warehouses = useSelector(selectWarehouses)

  const { t } = useTranslation('filters')
  const { goBack } = useHistory()

  const updateFilter = (name, value = '', additionalName = '', f = filters) => {
    const newVal = additionalName ? { ...f[name], [additionalName]: value } : value
    if (value !== '') setFilters({ ...f, [name]: newVal })
    else {
      const copy = { ...f }
      if (additionalName) {
        delete copy[name][additionalName]
        if (Object.keys(copy[name]).length === 0) delete copy[name]
      } else delete copy[name]
      setFilters(copy)
    }
  }

  return (
    <Popup>
      <div className='popup--filter'>
        <div className='popup__title'>
          <div>{t('chooseFilters')}</div>
        </div>

        <div className='popup__main center'>
          <div>
            <div className='popup__list'>
              {fields.map(({ name, disabled, label, type, options, placeholder, attr }, i) => <div
                key={i}
                className='element'>
                <div className='element__title'>{label}</div>
                {name === 'date' ? (
                  <div className='element__date group'>
                    <DateInput
                      start
                      min={attr?.min}
                      disabled={disabled}
                      max={filters.date?.end || attr?.max}
                      value={filters.date?.start || ''}
                      updateFilter={updateFilter} />

                    <DateInput
                      max={attr?.max}
                      disabled={disabled}
                      min={filters.date?.start || attr?.min}
                      value={filters.date?.end || ''}
                      updateFilter={updateFilter} />
                  </div>
                ) : (type === 'section' || type === 'multiSelect') ? (
                  <Select
                    secondaryTheme
                    disabled={disabled}
                    multiple={type === 'multiSelect'}
                    value={filters[name] || (type === 'multiSelect' ? [] : '')}
                    options={name === 'warehousesIds'
                      ? [
                        ...options,
                        ...warehouses.map(({ objectId, typeName, name, placeShortAddress }) => ({ value: objectId, name: `${typeName} nr.${name} (${placeShortAddress})` }))
                      ]
                      : options
                    }
                    setValue={value => {
                      updateFilter(name, value)
                    }} />
                ) : <input
                  type={type}
                  disabled={disabled}
                  value={filters[name]}
                  placeholder={placeholder}
                  onChange={e => {
                    updateFilter(name, e.target.value)
                  }}
                />}
              </div>)}
            </div>

            <div className='popup__buttons center'>
              <div
                className='button__cancel'
                onClick={() => {
                  saveFilters({})
                  goBack()
                }}>{t('removeFilters')}</div>
              <div
                className='button__add'
                onClick={() => {
                  saveFilters(filters)
                  goBack()
                }}>{t('show')}</div>
            </div>
          </div>
        </div>
      </div>
    </Popup>
  )
}

export default FilterPopup